import React from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const InvitationStatusFormatter = ({ value, lan }) => {
  let icon = null;
  let text = '';
  let className = 'Fielder-invitation-status';
  switch (value) {
    case 'INVITATION_PENDING':
      icon = <AccessTimeIcon style={{ fontSize: 14, marginRight: 6 }} />;
      text = lan.pendentingInvitation;
      break;
    default:
      text = 'Status Unknown';
      break;
  }
  return (
    <div className='d-flex align-items-center'>
      {icon}
      <span className={className}>{text}</span>
    </div>
  );
};

export default InvitationStatusFormatter;
